import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { ManagementTypeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ManagementTypeCreateDto,
  ManagementTypeDto,
  ManagementTypeExcelDownloadDto,
  ManagementTypeUpdateDto,
} from '../proxy/planning/dtos/management-type';
import { MANAGEMENTTYPE_CONFIG, MANAGEMENTTYPE_FIELDS } from './management-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-management-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ManagementTypeService, ConfirmationService],
  templateUrl: './management-type.html',
  styleUrl: './management-type.scss',
})
export class ManagementType extends BaseCrudComponent<
  ManagementTypeDto,
  ManagementTypeCreateDto,
  ManagementTypeUpdateDto,
  ManagementTypeExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(ManagementTypeService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('ManagementType', ids),
  };
  config = MANAGEMENTTYPE_CONFIG;
  fields = MANAGEMENTTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: ManagementTypeDto): ManagementTypeUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ManagementType';
  }
}
